import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/theme/ThemeContext";

export function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            className={`rounded-full ${isDark ? 'bg-black/60' : 'bg-white/70'} shadow-lg transition-all duration-200 hover:scale-110 hover:shadow-xl focus:outline-none`}
            style={{ width: 40, height: 40, minWidth: 40, minHeight: 40, padding: 0 }}
            aria-label="Toggle theme"
        >
            {theme === "dark" ? (
                <Sun className="h-5 w-5 text-orange-400 transition-transform duration-200" />
            ) : (
                <Moon className="h-5 w-5 text-black transition-transform duration-200" />
            )}
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
} 